import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useStaticQuery, graphql } from 'gatsby';
import { Box, Heading } from 'grommet';
import RichText from './RichText';

const StyledTextHero = styled.div`
  background-image: ${({ backgroundImage }) => `url('${backgroundImage}')`};
  color: #FFFFFF;
  > div {
    ${({ theme }) => theme.custom.helpers.LayoutContainer``};
    text-align: center;
    padding-top: 40px;
    padding-bottom: 40px;
    @media ${({ theme }) => theme.custom.layouts.above_large} {
      padding-top: 80px;
      padding-bottom: 80px;
      > div {
        margin: 0 auto;
        width: calc((8 / 12) * 100%);
      }
    }
  }
`;

const StyledRichText = styled(RichText)`
  color: #FFFFFF;
`;

const TextHero = ({ title, subtitle }) => {
  const { gridBackground } = useStaticQuery(graphql`
    {
      gridBackground: contentfulAsset(title: { eq: "Grid Background" }) {
        file {
          url
        }
      }
    }
  `);

  return (
    <StyledTextHero backgroundImage={gridBackground.file.url}>
      <div>
        <div>
          <Box pad={{ bottom: '20px' }}>
            <Heading color="#FFFFFF" level="1">{title}</Heading>
          </Box>
          <StyledRichText richText={subtitle} />
        </div>
      </div>
    </StyledTextHero>
  );
};

TextHero.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.object.isRequired,
};

export default TextHero;
